import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { HTTPError } from '../libs';
export var ApiClientEvents;

(function (ApiClientEvents) {
  ApiClientEvents["OPEN"] = "onopen";
  ApiClientEvents["ERROR"] = "onerror";
  ApiClientEvents["INIT"] = "INIT";
  ApiClientEvents["HEARTBEAT"] = "HEARTBEAT";
  ApiClientEvents["LOGOUT"] = "LOGOUT";
})(ApiClientEvents || (ApiClientEvents = {}));

export var ApiClientState;

(function (ApiClientState) {
  ApiClientState[ApiClientState["CONNECTING"] = 0] = "CONNECTING";
  ApiClientState[ApiClientState["OPEN"] = 1] = "OPEN";
  ApiClientState[ApiClientState["CLOSED"] = 2] = "CLOSED";
})(ApiClientState || (ApiClientState = {}));

export var ApiClient = /*#__PURE__*/function () {
  function ApiClient(_ref) {
    var serviceUrl = _ref.serviceUrl;

    _classCallCheck(this, ApiClient);

    _defineProperty(this, "baseUrl", void 0);

    this.baseUrl = serviceUrl;
  }

  _createClass(ApiClient, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(serviceTicket) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch("".concat(this.baseUrl, "/init?ticket=").concat(serviceTicket), {
                  credentials: 'include'
                });

              case 2:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 5;
                  break;
                }

                throw new HTTPError(response);

              case 5:
                return _context.abrupt("return", true);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init(_x) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "verify",
    value: function () {
      var _verify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetch("".concat(this.baseUrl, "/session"), {
                  credentials: 'include'
                });

              case 2:
                response = _context2.sent;

                if (!(!response.ok && response.status !== 401)) {
                  _context2.next = 5;
                  break;
                }

                throw new HTTPError(response);

              case 5:
                return _context2.abrupt("return", response.ok);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function verify() {
        return _verify.apply(this, arguments);
      }

      return verify;
    }()
  }, {
    key: "subscribe",
    value: function subscribe(_ref2) {
      var heartbeatTimeout = _ref2.heartbeatTimeout;
      return new EventSource("".concat(this.baseUrl, "/subscribe"), {
        withCredentials: true,
        // @ts-ignore: heartbeatTimeout is used by EventSourcePolyfill,
        // this property will be ignored by native EventSource
        heartbeatTimeout: heartbeatTimeout
      });
    }
  }]);

  return ApiClient;
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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